import Cookies from 'js-cookie';

import { getServer } from '@/api';
import { Configuration } from '@/api/api-client';

export const getBaseUrl = () => {
  const currentDomain = window.location.hostname;

  const server = getServer(currentDomain);

  if (!server) {
    console.warn(`No configuration found for domain: ${currentDomain}`);
    throw new Error(`No configuration found for domain: ${currentDomain}`);
  } else {
    return server.apiUrl;
  }
}

export const createApiConfig = () => {
  const baseURL = getBaseUrl();

  return new Configuration({
    basePath: baseURL,
    accessToken: Cookies.get('accessToken') || '',
    baseOptions: {
        withCredentials: true
      }
  });
};
